export const API_URL = "https://api.ciertacorp.com";
// export const API_URL = "https://dashboard.shop-link.online";
// export const API_URL =  "http://localhost:5000";